import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import BootstrapAccordion from "react-bootstrap/Accordion";
import { ChevronDownRounded } from "@/icons";
import styles from "./accordion.module.scss";

export default function Accordion(props) {
  const {
    items,
    imageMapping,
    imageClassName,
    className,
    itemClassName,
    headerClassName,
    bodyClassName,
    toggleClassName,
    alwaysOpen = true,
    ...extraProps
  } = props;

  return (
    <>
      <BootstrapAccordion alwaysOpen={alwaysOpen} className={cx(styles.accordion, className)} {...extraProps}>
        {items.map((item, index) => (
          <BootstrapAccordion.Item
            key={index}
            eventKey={index}
            className={cx(styles.accordionItem, itemClassName)}
          >
            {imageMapping && (
              <div className={imageClassName}>
                <img src={imageMapping[item.icon]} alt="image icon" />
              </div>
            )}
            <div className="headerAndBodyWrapper">
              <BootstrapAccordion.Header className={cx(styles.accordionHeader, headerClassName)}>
                <span>{item.title}</span>
                <ChevronDownRounded className={cx(styles.icon, toggleClassName)} />
              </BootstrapAccordion.Header>
              <BootstrapAccordion.Body
                className={cx(styles.accordionBody, bodyClassName)}
                dangerouslySetInnerHTML={{ __html: item.htmlContent }}
              />
            </div>
          </BootstrapAccordion.Item>
        ))}
      </BootstrapAccordion>
    </>
  );
}

Accordion.propTypes = {
  items: PropTypes.array,
  imageMapping: PropTypes.object,
  imageClassName: PropTypes.string,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  toggleClassName: PropTypes.string,
  alwaysOpen: PropTypes.bool,
};
